function onServerError() {
    return {
        restrict: 'E',
        scope: {
            show: '@',
            status: '@',
            error: '@'
        },
        transclude: false,
        template: '<div ng-show="{{show}}" class="server-error">An unexpected error has occurred. Please try again later. If problem persists, please contact your <a href="/storefinder">local branch.</a></div>'
    };
}

export default onServerError;


// WEBPACK FOOTER //
// ./src/app/directives/service-error-directive.js